import React, { useState, useEffect } from 'react';
import { Map } from "@strava/feature-global-wasm-mre";
import type { LatLng } from "../types";

interface MapScrubberProps {
  locationStream: LatLng[];
}

export const MapScrubber = ({ locationStream }: MapScrubberProps) => {
  const [rabbit, setRabbit] = useState<LatLng | null>(null);

  // Attach and detach event listeners
  useEffect(() => {
    const onSetRabbitPosition = (e): void => {
      const { index } = e.detail;
      const latLng = locationStream?.[index];
      if (latLng) {
        setRabbit(latLng);
      }
    };

    const onHideRabbit = (): void => {
      setRabbit(null);
    };

    document.addEventListener('SetRabbitPosition', onSetRabbitPosition);
    document.addEventListener('HideRabbit', onHideRabbit);

    return () => {
      document.removeEventListener('SetRabbitPosition', onSetRabbitPosition);
      document.removeEventListener('HideRabbit', onHideRabbit);
    };
  }, [locationStream]);

  if (!rabbit) {
    return null;
  }

  return <Map.Scrubber latLng={rabbit} />;
};

export default MapScrubber;
